import React, { useState } from 'react';
import { Menu, Search, Star, LineChart, PieChart, LogIn } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SlidingMenu from './navigation/SlidingMenu';
import AuthModal from './modals/AuthModal';
import UserAvatar from './auth/UserAvatar';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  return (
    <>
      <nav className="torii-header">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-xl font-bold">
              Track-Assetz
            </Link>
            
            <div className="flex items-center space-x-6">
              <div className="hidden md:flex items-center space-x-6">
                <Link
                  to="/"
                  className={`nav-link flex items-center px-3 py-2 rounded-md ${
                    location.pathname === '/' ? 'active' : ''
                  }`}
                >
                  <PieChart className="h-5 w-5 mr-1" />
                  <span>Home</span>
                </Link>

                <Link
                  to="/search-funds"
                  className={`nav-link flex items-center px-3 py-2 rounded-md ${
                    location.pathname === '/search-funds' ? 'active' : ''
                  }`}
                >
                  <Search className="h-5 w-5 mr-1" />
                  <span>Funds</span>
                </Link>

                <Link
                  to="/search-stocks"
                  className={`nav-link flex items-center px-3 py-2 rounded-md ${
                    location.pathname === '/search-stocks' ? 'active' : ''
                  }`}
                >
                  <LineChart className="h-5 w-5 mr-1" />
                  <span>Stocks</span>
                </Link>
              </div>

              {user ? (
                <button
                  onClick={() => setIsMenuOpen(true)}
                  className="flex items-center focus:outline-none"
                >
                  <UserAvatar email={user.email || ''} imageUrl={user.photoURL || ''} size="sm" />
                </button>
              ) : (
                <button
                  onClick={() => setIsAuthModalOpen(true)}
                  className="flex items-center space-x-2 px-3 py-2 rounded-md hover:bg-blue-50 text-blue-600"
                >
                  <LogIn className="h-5 w-5" />
                  <span className="hidden md:inline">Sign In</span>
                </button>
              )}
            </div>

            {/* Mobile Navigation */}
            <div className="flex md:hidden items-center space-x-4">
              <Link
                to="/"
                className={`nav-link flex items-center px-2 py-1 rounded-md ${
                  location.pathname === '/' ? 'active' : ''
                }`}
              >
                <PieChart className="h-5 w-5" />
              </Link>

              <Link
                to="/search-funds"
                className={`nav-link flex items-center px-2 py-1 rounded-md ${
                  location.pathname === '/search-funds' ? 'active' : ''
                }`}
              >
                <Search className="h-5 w-5" />
              </Link>

              <Link
                to="/search-stocks"
                className={`nav-link flex items-center px-2 py-1 rounded-md ${
                  location.pathname === '/search-stocks' ? 'active' : ''
                }`}
              >
                <LineChart className="h-5 w-5" />
              </Link>

              {user ? (
                <button
                  onClick={() => setIsMenuOpen(true)}
                  className="flex items-center focus:outline-none"
                >
                  <UserAvatar email={user.email || ''} imageUrl={user.photoURL || ''} size="sm" />
                </button>
              ) : (
                <button
                  onClick={() => setIsAuthModalOpen(true)}
                  className="flex items-center px-2 py-1 rounded-md hover:bg-blue-50 text-blue-600"
                >
                  <LogIn className="h-5 w-5" />
                </button>
              )}
            </div>
          </div>
        </div>

        <SlidingMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      </nav>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </>
  );
}